import { FiUser, FiEdit2, FiTrash2 } from "react-icons/fi"

const ACQUISITION_LABELS: Record<string, string> = {
  EMPLOYER: "Right acquired as employer",
  LEGAL_SUCCESSOR: "Right acquired as legal successor",
  AGREEMENT: "Right acquired by agreement"
}

export default function SavedInventorBox({
  inventor,
  onEdit,
  onDelete
}: {
  inventor: any
  onEdit: () => void
  onDelete: () => void
}) {
  const displayName =
    `${inventor.firstName || ""} ${inventor.lastName || ""}`.trim() ||
    inventor.name ||
    "Inventor"

  const residence = inventor.residence || {}
  const residenceLine = [residence.postalCode, residence.city, residence.country]
    .filter(Boolean)
    .join(", ")

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3.5 shadow-sm">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#e6edf5] text-dantzBlue">
          <FiUser size={18} />
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
              Inventor
            </span>

            <div className="flex gap-1.5">
              {inventor.applicantIsInventor && (
                <span className="rounded-full bg-[#e6edf5] px-2 py-0.5 text-[10px] font-medium text-dantzBlue">
                  Applicant
                </span>
              )}
              {inventor.deceased && (
                <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-500">
                  Deceased
                </span>
              )}
              {inventor.waiverIndicator && (
                <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-500">
                  Waived
                </span>
              )}
            </div>
          </div>

          <p className="mt-0.5 truncate text-sm font-medium text-gray-800">
            {displayName}
          </p>

          {residenceLine ? (
            <p className="truncate text-xs text-gray-600">{residenceLine}</p>
          ) : (
            inventor.address && (
              <p className="truncate text-xs text-gray-600">{inventor.address}</p>
            )
          )}

          {!inventor.applicantIsInventor && inventor.rightAcquisition && (
            <p className="truncate text-xs text-gray-500">
              {ACQUISITION_LABELS[inventor.rightAcquisition] ||
                inventor.rightAcquisition}
              {inventor.rightAcquisition === "AGREEMENT" && inventor.agreementDate
                ? ` (${inventor.agreementDate})`
                : ""}
            </p>
          )}

          <div className="mt-2.5 flex gap-4 border-t border-gray-100 pt-2.5">
            <button
              type="button"
              onClick={onEdit}
              className="inline-flex items-center gap-1 text-xs font-medium text-dantzBlue hover:underline"
            >
              <FiEdit2 size={13} /> Edit
            </button>

            {!inventor.applicantIsInventor && (
              <button
                type="button"
                onClick={onDelete}
                className="inline-flex items-center gap-1 text-xs font-medium text-red-600 hover:underline"
              >
                <FiTrash2 size={13} /> Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
